// Promisify ADL.XAPIWrapper.getState
const getState = function(
    activityId, agent, stateId, registration = null, since = null) {
    const codes = {
        'Request error: aborted': 'request_aborted',
        404: 'no_user_data'
    };
    Logger.info('getState request', {
        activityId,
        agent,
        stateId,
        registration,
        since,})
    return new Promise((resolve, reject) => {
        ADL.XAPIWrapper.getState(
            activityId,
            agent,
            stateId,
            registration,
            since,
            function(r, xhr, response){
                if (response === null) {
                    return reject({
                        status: 'error',
                        code: 'no_user_data',
                    });
                }


                if (xhr.status !== 200) {
                    return reject({
                        status: 'error',
                        message: response,
                        code: codes[xhr.status] || 'error_unknown',
                    });
                }

                return resolve(response);
            }
        );
    });
};

window.LRSConnector = Component.extend({

    initialize: function(params) {
        this.name = 'LRSConnector';
        this.lms = params.lms;
        this.agent = {};
        // this.state = [];
        this.statementsXML = params.statementsXML;

        this.configure(params.endpoint, params.user, params.password);
    },

    setup: function(container) {
        this.container = container;

        // this.load();
        // this.setupAgent();
        // this.setupManager();
    },

    setupManager: function() {
        // Logger.info("LrsConnector.setupManager")
        // debugger;
        this.manager = new StatementsManager({
            container: this.container,
            path: this.statementsXML,
            agent: this.agent
        });
    },

    startSessionsListeners: function() {
        Logger.info('LrsConnector.startSessionsListeners');
        this.listenTo(
            this.manager,
            'onStatementsReady',
            this.handleStatementsReady
        );
        this.listenTo(
            this.container.session,
            'onChangeSlide onJunctionUpdate',
            this.handleChangePage
        );
        this.listenTo(
            this.container.componentList.FirebaseStorage,
            'onUserPropertyUpdated',
            this.handleFirebaseUpdate
        );
    },

    handleFirebaseUpdate: function(e) {
        Logger.info('LrsConnector.handleFirebaseUpdate', e);

        this.setupAgent(`${e.user.firstName} ${e.user.lastName}`, e.user.email);
    },

    handleChangePage: function(e) {

        if (!this.container.componentList.FirebaseStorage.currentUser()) {
            return;
        }

        container.storage.save();

        const activityId = 'http://adlnet.gov/expapi/activities/question';
        const agent = {
            mbox: `mailto:${this.container.componentList.FirebaseStorage.data().email}`,
            name: this.container.componentList.FirebaseStorage.data().name,
        };
        const stateId = this.attributes.courseID; // '0877TURT';
        const registration = null;
        const state = {
            'cmi': JSON.stringify(this.container.tracking.courseProperties.cmi),
            'suspend_data': JSON.stringify(this.container.tracking.courseProperties.suspendData),
            'user_agent': navigator.userAgent
        };

        Logger.info('State.Save.CMI', state.cmi);
        Logger.info('State.Save.SUSPEND', state.suspend_data);
        Logger.info("State.Save.CMI.length == ", String( state.cmi ).length) ;
        Logger.info("State.Save.SUSPEND.length == ", String(state.suspend_data).length);

        const matchHash = null;
        const noneMatchHash = null;
        const callback = function(e) {
            Logger.info('State.save.success', container.storage.getBookmark());
        };

        ADL.XAPIWrapper.sendState(
            activityId, agent, stateId, registration, state, matchHash,
            noneMatchHash, callback
        );
    },
    handleStatementsReady: function(statements) {
        this.send(statements);
        // this.handleChangePage(null);
    },

    loadStateByEmail(email) {
        Logger.info("Lrs.loadStateByEmail", email);
        email = (email || '').toLowerCase();
        return new Promise(async (resolve, reject) => {

            const activityId = 'http://adlnet.gov/expapi/activities/question';
            const agent = {mbox: `mailto:${email}`};
            const stateId = this.attributes.courseID; // '0877TURT';
            Logger.info("Lrs.loadStateByEmail.details", activityId, agent, stateId);
            let result = await getState(activityId, agent, stateId).catch(error => error);
            
            if (result.status === 'error') {
                return reject(result);
            }
            
            const cmi = JSON.parse(result['cmi']);
            const suspend = JSON.parse(result['suspend_data']);

            Logger.info("State.Read.CMI.length == ", String(result['cmi']).length) ;
            Logger.info("State.Read.SUSPEND.length == ", String(result['suspend_data']).length);
            Logger.info('State.Read.CMI', result["cmi"]);
            Logger.info('State.Read.SUSPEND', result["suspend_data"]);

            if (cmi && cmi !== -1) {
                container.tracking.courseProperties.cmi = new CmiDataItems(cmi);
            }
            if (suspend && suspend !== -1) {
                container.tracking.courseProperties.suspendData = new SuspendDataItems(suspend);
            }

            container.router.pages.each(function(model) {
                const page = container.courseData.getPageById(model.id);
                if (!page) {
                    return;
                }
                const status = container.tracking.courseProperties.getItem(page.pageID());
                page.setStatus(status);
            }, this);

            container.storage.load();


            resolve(result);
        });
    },

    configure: function(endpoint, user, password) {
        ADL.XAPIWrapper.changeConfig({
            endpoint: endpoint,
            user: user,
            password: password,
            strictCallbacks: true,
        });

        if (!ADL.XAPIWrapper.testConfig()) {
            Logger.error('LRS endpoint not configured.');
        }

        Logger.info("Lrs.configure", ADL.XAPIWrapper);
    },

    setupAgent: function(name, email) {
        email = (email || '').toLowerCase();
        Logger.info('LrsConnector.setupAgent', name, email);
        this.agent.email = email;
        this.agent.id = email;
        this.agent.name = name;
        this.agent.lms = this.lms;

        this.trigger('onAgentUpdated', {
            target: this,
            agent: this.agent
        });

        // if (this.agent.name == null || this.agent.name === '') {
        //     this.agent.name = LRSConnector.DEFAULT_AGENT_NAME;
        // }
        // if (this.agent.id == null || this.agent.id === '') {
        //     this.agent.id = LRSConnector.DEFAULT_AGENT_ID;
        // }



        this.save();
    },

    send: function(statements) {
        Logger.trace('LRSConnector: sending statements', statements);

        let attempts = 0;
        const callback = function(err, res, body) {

            Logger.info("Lrs.Statements.response", err, res, body);
            if (!err) {
                return;
            } // success, end recursion

            Logger.error('LRSConnector', 'failed to send statements', err);

            attempts++;
            if (attempts < LRSConnector.MAX_ATTEMPTS) {
                Logger.info(
                    'LRSConnector', 'retrying to send statements, attempts:',
                    attempts
                );

                setTimeout(function() {
                    ADL.XAPIWrapper.sendStatements(statements, callback);
                }, LRSConnector.RETRY_DELAY);
            } else {
                Logger.info(
                    'LRSConnector',
                    'max attempts reached, giving up on sending statements, attempts:',
                    attempts
                );
            }
        };

        ADL.XAPIWrapper.sendStatements(statements, callback);
    },

    load: function(name, email) {
        email = (email || '').toLowerCase();
        // const storage = this.container.storage;
        // const agent = storage.getItem(LRSConnector.AGENT_KEY);

        // if (agent !== -1) {
        //     this.agent = agent;
        // }

        // Logger.info("LrsConnector.load", name, email)
        // this.load();
        this.setupAgent(name, email);
        this.setupManager();
        this.startSessionsListeners();

        this.trigger('onLoad', {
            target: this,
            agent: this.agent
        });
    },

    save: function() {
        // if (!this.agent) {
        //     return;
        // }
        // const storage = this.container.storage;
        // storage.setItem(LRSConnector.AGENT_KEY, this.agent);
    },

}, {
    DEFAULT_AGENT_NAME: null,
    DEFAULT_AGENT_LMS: 'http://default.lms',
    DEFAULT_AGENT_ID: null,

    AGENT_KEY: 'xapi_agent',

    MAX_ATTEMPTS: 3,
    RETRY_DELAY: 3000, // ms
});
